/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UnmarkRiskResultsFalsePositiveRequestBody = {
  /**
   * IDs of the risk results to restore.
   */
  resultIds: Array<string>;
};

/** @internal */
export type UnmarkRiskResultsFalsePositiveRequestBody$Outbound = {
  result_ids: Array<string>;
};

/** @internal */
export const UnmarkRiskResultsFalsePositiveRequestBody$outboundSchema:
  z.ZodMiniType<
    UnmarkRiskResultsFalsePositiveRequestBody$Outbound,
    UnmarkRiskResultsFalsePositiveRequestBody
  > = z.pipe(
    z.object({
      resultIds: z.array(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        resultIds: "result_ids",
      });
    }),
  );

export function unmarkRiskResultsFalsePositiveRequestBodyToJSON(
  unmarkRiskResultsFalsePositiveRequestBody:
    UnmarkRiskResultsFalsePositiveRequestBody,
): string {
  return JSON.stringify(
    UnmarkRiskResultsFalsePositiveRequestBody$outboundSchema.parse(
      unmarkRiskResultsFalsePositiveRequestBody,
    ),
  );
}
